import styles from './NoticesSection.module.css';
import HeadingAndIcon from '../../components/HeadingAndIcon/HeadingAndIcon';
import NoticeAnnouncementCard from '../../components/NoticeAnnouncementCard/NoticeAnnouncementCard';
import { CiCalendarDate } from 'react-icons/ci';
import Photo from '../../assets/images/Photo.png';
import { NavLink } from 'react-router';
const NoticesSection = () => {
  const notices = [
    {
      day: 'Mon',
      date: '18',
      image: Photo,
      message: 'There is a parents meeting tomorrow on May 27',
      sender: 'Principal',
      timeAgo: '5 min ago',
    },
    {
      day: 'Mon',
      date: '18',
      image: Photo,
      message: 'There is a parents meeting tomorrow on May 27',
      sender: 'Principal',
      timeAgo: '5 min ago',
    },
    {
      day: 'Mon',
      date: '18',
      image: Photo,
      message: 'There is a parents meeting tomorrow on May 27',
      sender: 'Principal',
      timeAgo: '5 min ago',
    },
  ];

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <HeadingAndIcon
          icon={<CiCalendarDate className={styles.headingIcon} />}
          heading="Notices"
        />
        <NavLink className={styles.viewAll} to={'calender/schoolcalender'}>
          View All
        </NavLink>
      </div>

      <div className={styles.notices}>
        {notices.map((n, i) => (
          <NoticeAnnouncementCard key={i} {...n} />
        ))}
      </div>

      <div className={styles.buttons}>
        <button className={styles.addNotice}>Add Notice</button>
      </div>
    </div>
  );
};

export default NoticesSection;
